export class Util {
	// https://www.g200kg.com/archives/2019/01/audioworklet-1.html
	public static addAudioWorklet(context: AudioContext, processor: any): Promise<void> {
		const f = `data:text/javascript,${encodeURI(processor.toString())}; registerProcessor("${processor.name}",${processor.name})`;
		return context.audioWorklet.addModule(f);
	}

	private constructor() {}
}
